import {writable} from "svelte/store";

const blogStore = writable([]);

const findById = id => {
    let result;
    blogStore.subscribe(items => {
        result = items.find(itm => itm.id === id);
    })
    return result;
};

const addNewBlog = newBlog => {
    blogStore.subscribe(blogList => {
        newBlog.id = blogList.length + 1;
    })
    blogStore.update(blogList => [...blogList, newBlog]);
}

const getBlogsCount = () => {
    let count;
    blogStore.subscribe(items => {count = items.length});
    return count;
}

export const blogs = {
    subscribe: blogStore.subscribe,
    set: blogStore.set,
    findById,
    addNewBlog,
    getBlogsCount
}